// @flow
import { theme } from "../theme";

type Props = {
  className?: string,
  fill?: string,
};

export const Tick = ({ className, fill = theme.palette.navy.light }: Props) => (
  <svg className={className} viewBox="0 0 32 32" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2929 24.7071C11.6834 25.0976 12.3166 25.0976 12.7071 24.7071L27.7071 9.70711C28.0976 9.31658 28.0976 8.68342 27.7071 8.29289C27.3166 7.90237 26.6834 7.90237 26.2929 8.29289L12 22.5858L5.70711 16.2929C5.31658 15.9024 4.68342 15.9024 4.29289 16.2929C3.90237 16.6834 3.90237 17.3166 4.29289 17.7071L11.2929 24.7071Z"
      fill={fill}
    />
  </svg>
);
